import type { IconProps } from '../types/IconProps.ts';
export const BarChart: IconProps = {
    name: 'BarChart',
    children: [
        `<path d="M3 3v17a1 1 0 0 0 1 1h17M7 6h4M7 11h12M7 16h8" />`,
    ]
};